// Lower case, without accents: "Hélène" is found by typing "helene".
export const normalizeForSearch = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

/**
 * The members whose first name, last name or email hold every word typed, in
 * any order, so that "dupont jean" finds Jean Dupont.
 */
export const filterMembers = (members, query) => {
  const words = normalizeForSearch(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return members;
  return members.filter((member) => {
    const haystack = normalizeForSearch(
      [member.firstname, member.lastname, member.email].join(' '),
    );
    return words.every((word) => haystack.includes(word));
  });
};
